import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './success-state.module.css';

type Props = {
    selectedPhoneNumber: string;
    startedFrom: 'marketing' | 'engagement';
};

export function SuccessState(props: Props) {
    return (
        <div className={styles.container}>
            <Illustration src='phone-configured' width={300} />
            <div className='flex flex-dir-col gap-8'>
                <Body size='large' isBold={true}>
                    Awesome! You’ve selected a new text number!
                </Body>
                <Body>
                    Your new number is {props.selectedPhoneNumber}. This will be used to send and
                    receive text messages within Nutshell SMS.
                </Body>
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    to={
                        props.startedFrom === 'marketing'
                            ? '/marketing/sms-setup'
                            : '/inbox/settings/sms'
                    }
                    variant='primary'
                    size='big'
                >
                    Back to SMS setup
                </Link>
            </div>
        </div>
    );
}
